
import Animation from '../../core/Animation'

const easeOutSin = function (t) {
  return Math.sin(Math.PI / 2 * t)
}

const formatNumber = (number) => {
  let str = '' + number
  if (number >= 1000000) {
    number = parseInt(number / 10000) / 100
    str = number + 'M'
  } else if (number >= 1000) {
    number = parseInt(number / 10) / 100
    str = number + 'K'
  }
  str = str.split(',').join('.')
  return str
}

export default class ElementNumber extends Animation {
  constructor (el, startValue, endValue, duration = 60, format = false, onUpdate = null, onComplete = null) {
    super()
    this._element = el
    this._startValue = startValue
    this._diffValue = endValue - startValue
    this._onUpdate = onUpdate
    this._onComplete = onComplete
    this._duration = duration
    this._format = format
  }

  update () {
    this.updateIn()
    // const value = parseInt(this._startValue + this._diffValue * easeOutSin(this._timeRatio))
    const value = parseInt(this._startValue + this._diffValue * this._timeRatio)
    this._element.html(this._format ? formatNumber(value) : value)
    //this.updateOut()

    if (this._onUpdate) this._onUpdate(this._timeRatio)
    if (this._time == this._duration) {
      this.dispose()
      if (this._onComplete) this._onComplete(this._element, value)
    }

  }

  dispose () {
    super.dispose()
  }
}